/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import { type ForwardedRef, forwardRef } from 'react';
import { type IconProps, Icon } from '../../components/icon/icon.component';

const RewindStrokeIcon = forwardRef((props: IconProps, ref: ForwardedRef<SVGSVGElement>) => {
  return (
    <Icon {...props} ref={ref}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M4 9.6715L6.47488 7.19663C9.40371 4.26779 14.1526 4.26779 17.0815 7.19663C20.0103 10.1255 20.0103 14.8744 17.0815 17.8032C14.1526 20.7321 9.40372 20.7321 6.47488 17.8032M4 9.6715V5.42886M4 9.6715H8.24265"
          strokeLinecap="round"
        />
      </svg>
    </Icon>
  );
});

export { RewindStrokeIcon };
